import { DownloadIcon } from "../../../shared/icons/DownloadIcon";
import { generateId } from "../../../shared/utils/generateId";
import { TFilePreviewer } from "../types";

export const FILE_PREVIEWER_ACTIONS = [
  {
    id: generateId(),
    actionType: "download",
    icon: <DownloadIcon />,
  },
];

export const MAX_STORED_LENGTH = 150_000;

export const ACCEPTABLE_AUDIO_FORMAT = ["mp3", "wav", "flac", "aiff", "ogg"];

export const ACCEPTABLE_VIDEO_FORMAT = ["mp4", "mpeg", "mov", "webm", "ogg"];

export const MAX_FILE_SIZE_MB = 150;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const FILE_TYPE_REGISTRY: TFilePreviewer = {
  pdf: {
    mimeType: "application/pdf",
    strategy: "blob",
    viewer: "frame",
    fileContent: null,
    extension: "pdf",
  },
  png: {
    mimeType: "image/png",
    strategy: "blob",
    viewer: "image",
    fileContent: null,
    extension: "png",
  },
  jpg: {
    mimeType: "image/jpeg",
    strategy: "blob",
    viewer: "image",
    fileContent: null,
    extension: "jpg",
  },
  md: {
    mimeType: "text/markdown",
    strategy: "as-text",
    viewer: "extracted-text",
    fileContent: null,
    extension: "md",
  },
  xml: {
    mimeType: "application/xml",
    strategy: "as-text",
    viewer: "frame",
    fileContent: null,
    extension: "xml",
  },
  drawio: {
    mimeType: "application/xml",
    strategy: "as-text",
    viewer: "frame",
    fileContent: null,
    extension: "drawio",
  },
  txt: {
    mimeType: "text/plain",
    strategy: "as-text",
    viewer: "extracted-text",
    fileContent: null,
    extension: "txt",
  },
  docx: {
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    strategy: "extract-text",
    viewer: "extracted-text",
    fileContent: null,
    extension: "docx",
  },
  doc: {
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    strategy: "extract-text",
    viewer: "extracted-text",
    fileContent: null,
    extension: "doc",
  },
  xlsx: {
    mimeType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    strategy: "extract-text",
    viewer: "extracted-text",
    fileContent: null,
    extension: "xlsx",
  },
  mp3: {
    mimeType: "audio/mpeg",
    strategy: "blob",
    viewer: "audio",
    fileContent: null,
    extension: "mp3",
  },
  flac: {
    mimeType: "audio/flac",
    strategy: "blob",
    viewer: "audio",
    fileContent: null,
    extension: "flac",
  },
  wav: {
    mimeType: "audio/wav",
    strategy: "blob",
    viewer: "audio",
    fileContent: null,
    extension: "wav",
  },
  mp4: {
    mimeType: "video/mp4",
    strategy: "blob",
    viewer: "video",
    fileContent: null,
    extension: "mp4",
  },
  mov: {
    mimeType: "video/quicktime",
    strategy: "blob",
    viewer: "video",
    fileContent: null,
    extension: "mov",
  },
  webm: {
    mimeType: "video/webm",
    strategy: "blob",
    viewer: "video",
    fileContent: null,
    extension: "webm",
  },
  ogg: {
    mimeType: "video/ogg",
    strategy: "blob",
    viewer: "video",
    fileContent: null,
    extension: "ogg",
  },
  unsupported: {
    mimeType: "application/octet-stream",
    strategy: "unsupported",
    viewer: "unsupported",
    fileContent: null,
    extension: "unsupported",
  },
};
